// src/screens/PaceSelect.jsx
import React from "react";
import { PACE_LABELS } from "../data/learningConfig";
import { Button, OptionCard, ScreenHeader, Stack } from "../components/ui";

const PACE_ORDER = ["easy", "medium", "hard"];

export default function PaceSelect({ pace, setPace, onContinue, onBack }) {
  const canContinue = Boolean(pace);

  return (
    <>
      <ScreenHeader
        title="fluent! – Lerntempo"
        subtitle="Wie schnell möchtest du fließend sprechen können?"
      />

      <Stack gap={2}>
        {PACE_ORDER.map((id) => (
          <OptionCard
            key={id}
            label={PACE_LABELS[id]}
            active={pace === id}
            onClick={() => setPace(id)}
          />
        ))}
      </Stack>

      <Stack gap={2} style={{ marginTop: "var(--fluent-space-5)" }}>
        <Button block onClick={onContinue} disabled={!canContinue}>
          Weiter zum Hauptmenü
        </Button>
        <Button block variant="secondary" onClick={onBack}>
          Zurück
        </Button>
      </Stack>
    </>
  );
}
